export type BlackoutType = 'PRODUCT' | 'VARIANT' | 'OPTION_VALUE' | 'MODIFIER' | 'BUNDLE';
export type BlackoutReason = 'OUT_OF_STOCK' | 'COMING_SOON';

export interface BlackoutItem {
  __typename: string;
  startingAt: string;
  expiry: string;
  reason: BlackoutReason;
  details?: string;
  productCode?: string;
  variantCode?: string;
  optionValueCode?: string;
  modifierCode?: string;
  bundleCode?: string;
  name?: string;
}

export interface BlackoutFormData {
  type: BlackoutType;
  itemCode: string;
  itemName?: string;
  reason: BlackoutReason;
  expiry: Date | null;
  startingAt?: Date;
}

export const BlackoutTypeLabels: Record<BlackoutType, string> = {
  PRODUCT: 'Product',
  VARIANT: 'Variant',
  OPTION_VALUE: 'Option Value',
  MODIFIER: 'Modifier',
  BUNDLE: 'Bundle'
};

export const BlackoutReasonLabels: Record<BlackoutReason, string> = {
  OUT_OF_STOCK: 'Out of Stock',
  COMING_SOON: 'Coming Soon'
};

export const getBlackoutType = (blackout: BlackoutItem): BlackoutType => {
  if (blackout.productCode) return 'PRODUCT';
  if (blackout.variantCode) return 'VARIANT';
  if (blackout.optionValueCode) return 'OPTION_VALUE';
  if (blackout.modifierCode) return 'MODIFIER';
  if (blackout.bundleCode) return 'BUNDLE';
  return 'PRODUCT'; // default
};

export const getItemCode = (blackout: BlackoutItem): string => {
  return blackout.productCode ||
    blackout.variantCode ||
    blackout.optionValueCode ||
    blackout.modifierCode ||
    blackout.bundleCode ||
    '';
};

export const getItemDisplayName = (blackout: BlackoutItem): string => {
  const code = getItemCode(blackout);
  if (blackout.name) {
    return `${code} - ${blackout.name}`;
  }
  return code;
};